import React, { useContext } from 'react'
import { IframeContext } from './IframeConn'

export type NotificationsContextState = {
  notificationsCheck: () => Promise<NotificationPermission>
  notificationsAsk: () => Promise<NotificationPermission>
  notify: (body: string, title?: string) => void
}

export const NotificationsContext =
  React.createContext<NotificationsContextState>({
    notificationsAsk: () => null as unknown as Promise<NotificationPermission>,
    notificationsCheck: () =>
      null as unknown as Promise<NotificationPermission>,
    notify: () => {},
  })

type Props = { children: React.ReactNode }

const Notifications: React.FC<Props> = ({ children }) => {
  const { parentRef } = useContext(IframeContext)

  const notificationsCheck = () =>
    window.isIframe && parentRef.current
      ? parentRef.current.notificationsCheck()
      : (new Promise(r =>
          r(
            typeof Notification !== 'undefined'
              ? Notification.permission
              : 'denied'
          )
        ) as Promise<NotificationPermission>)

  const notificationsAsk = () =>
    window.isIframe && parentRef.current
      ? parentRef.current.notificationsAsk()
      : (new Promise(r =>
          r(Notification.requestPermission())
        ) as Promise<NotificationPermission>)

  const notify = (body: string, title?: string) => {
    window.isIframe && parentRef.current
      ? parentRef.current.notify(body, title)
      : new Notification(title || 'Agent Inteliwise', {
          body,
        })
  }

  return (
    <NotificationsContext.Provider
      value={{
        notificationsAsk,
        notificationsCheck,
        notify,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  )
}

export default Notifications
